export const GET_RECEIPT_SUCCESS = "GET_RECEIPT_SUCCESS";
export const GET_RECEIPT_FAILURE = "GET_RECEIPT_FAILURE";

export const GET_USER_RECEIPT_SUCCESS = "GET_USER_RECEIPT_SUCCESS";
export const GET_USER_RECEIPT_FAILURE = "GET_USER_RECEIPT_FAILURE";
